import localforage from 'localforage'
import { escapeAndLinkify } from '@/helpers'

export const setChat = (state, chat) => {
  state.chat = chat
}

export const setConversation = (state, conversation) => {
  state.conversation = conversation
}

export const setMessages = (state, messages) => {
  state.messages = messages.map(message => {
    message.body = escapeAndLinkify(message.body)

    return message
  })
}

export const setMessagesChannel = (state, messages) => {
  messages.map(message => {
    message.body = escapeAndLinkify(message.body)

    state.messages.push(message)
  })
}

export const addLastMessage = (state, message) => {
  state.messages.push(message)
}

export const addMessage = async (state, { uuid, from, body, files, success }) => {
  const message = _.find(state.messages, { uuid })

  if (message) {
    message.body = body
    message.files = files
    return
  }

  state.messages.push({
    uuid,
    body: escapeAndLinkify(body),
    created_at: moment(),
    from,
    files,
    success
  })
}

export const updateChatWidget = (state, data) => {
  state.chatWidget = {
    ...state.chatWidget,
    ...data
  }

  return localforage.setItem('chat-widget-v2', state.chatWidget)
}

export const removeMessage = async(state, message) => {
  state.messages = state.messages.filter(m => m.uuid !== message.uuid)
}

export const setChannels = (state, channels) => {
  state.channels = channels
}